import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'

const Schema = ({regions}) => {
    const faqItems = regions?.[0]?.components?.map((component) => component?.data) || []

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
            ...faqItems.map((item) => ({
                '@type': 'Question',
                name: item?.title || '',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: item?.content || '',
                    ...(item?.buttonLink
                        ? {
                              url: item.buttonLink
                          }
                        : {}),
                    ...(item?.imageUrl
                        ? {
                              image: item.imageUrl
                          }
                        : {})
                }
            }))
        ]
    }

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
    )
}

Schema.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        title: PropTypes.string,
                        content: PropTypes.string,
                        buttonLink: PropTypes.string,
                        imageUrl: PropTypes.string
                    })
                })
            )
        })
    )
}

export default Schema
